import styled from "styled-components";
import { Link } from "react-router-dom";

const Logo = styled(Link)`
  font-size: 1.2rem;
  font-weight: 800;
`;

export default Logo;
